import lightGrayButtonRule from '../../../light-gray/background/default/light';

const light = (params) => lightGrayButtonRule(params);

export default light;
